
















































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import { ThingGroupsApi } from '@/api';
import Toast from '@/components/display/toast.vue';

@Component({
	components: {
		secondaryNav,
	},
})
export default class ThingGroupList extends Vue {
	public transceiverForm = {};
	public siteForm = {};
	public currentPage = 1;
	public perPage = 20;
	public totalRows = 0;
	public thingFields = [];
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public syncStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public transceivers = [];
	public thingGroups = [];
	public filter = '';
	public active = '';
	public quickFilterList = [];
	public modalData = {};
	public thingGroupList = [];

	public transceiverFields = [
		{ key: 'transceiverSerialNumber', label: 'Transceiver Serial Number', sortable: true },
		{ key: 'transceiverFirmwareVersion', label: 'Transceiver Firmware Version', sortable: true },
		{ key: 'thingGroupFirmwareVersion', label: 'Thing Group Firmware Version', sortable: true },
		{ key: 'siteName', label: 'Site Name', sortable: true },
		{
			key: 'siteThingGroupName',
			label: 'Site Thing Group Name (editable)',
			sortable: true,
			type: 'modal',
		},
		{
			key: 'thingGroupName',
			label: 'Transceiver Thing Group Name',
			sortable: true,
		},
	];

	public selectedRow = {};
	public selectedCell = null;
	private api: ThingGroupsApi;

	constructor() {
		super();
		this.api = new ThingGroupsApi();
	}

	public onFiltered(filteredItems) {
		// Trigger pagination to update the number of buttons/pages due to filtering
		this.totalRows = filteredItems.length;
	}

	public handleEditCell(data, field) {
		this.selectedCell = field.key;
		if (data) {
			this.selectedRow = { [data.item['transceiverId']]: true };
		}
		if (field.type === 'modal') {
			this.$bvModal.show('modal-edit-site-thing-group');
			this.modalData = data.item;
		}
	}

	public reload() {
		this.$root.$emit('bv::refresh::table', 'transceivers-datatable');
	}

	public created() {
		this.load();
	}

	public async sync() {
		this.syncStatus = 'PENDING';
		let data: any = [];
		// console.log('start');
		try {
			const response = await this.api.syncThingGroups();
			data = response.data.data;
			// this.thingGroups = data.sort((a, b) => (a.name > b.name) ? 1 : -1);
		} catch (e) {
			this.syncStatus = 'ERROR';
			console.log(e);
		}
		// console.log('end');
		this.syncStatus = 'OK';
		this.load();
	}

	public async load() {
		let data: any = [];
		try {
			const thingGroupList = await this.api.getThingGroups({
				params: {
					perPage: 250,
				},
			});
			const response = await this.api.getOtaManagerData();
			data = response.data;
			this.transceivers = data;
			this.thingGroupList = thingGroupList.data.data.map(({ name }) => name).sort();
			this.totalRows = this.transceivers.length;
		} catch (e) {
			console.log(e);
		}

		this.submitStatus = 'OK';
	}

	public changeTransceiverThingGroup(data) {
		this.transceiverForm = {};
		this.transceiverForm[data.item.transceiverId] = data.item.thingGroupName;
		this.changeThingGroup('transceiver');
	}

	public changeSiteThingGroup(data) {
		this.siteForm = {};
		this.siteForm[data.siteId] = data.siteThingGroupName;
		this.changeThingGroup('site');
	}

	public async changeThingGroup(type) {
		this.submitStatus = 'PENDING';
		try {
			if (type === 'transceiver') {
				const response = await this.api.transceiverThingGroups({ data: this.transceiverForm });
			} else if (type === 'site') {
				const response = await this.api.siteThingGroups({ data: this.siteForm });
			}
		} catch (e) {
			// console.log("caught", e);
			let error;
			if (e.response) {
				error = 'Thinggroup not assigned ' + e.response.data.message;
				// console.log("error received response");
			} else if (e.request) {
				// console.log("no response");
				error = 'Thinggroup not assigned, network Error';
			} else {
				// console.log("unknown Error");
				error = 'Thinggroup not assigned, unknown Error';
			}
			// const error = e.response.data.errors.name[0];

			new Toast().makeToast(error, `${type} Thing Group Not Changed`, 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}
		this.load();
		new Toast().makeToast(
			`${type} Thing Group Succesfully Changed `,
			'Thing Group Changed',
			'success',
		);
	}
}
